export enum TypeChoices {
  SMART_SUGGESTION = "SMART_SUGGESTION",
  USER_ENTERED = "USER_ENTERED",
  AUTO_POPULATED = "AUTO_POPULATED",
}
